import { render, staticRenderFns } from "./DevAxForm.vue?vue&type=template&id=522104a0&scoped=true&"
import script from "./DevAxForm.vue?vue&type=script&lang=ts&"
export * from "./DevAxForm.vue?vue&type=script&lang=ts&"
import style0 from "./DevAxForm.vue?vue&type=style&index=0&id=522104a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522104a0",
  null
  
)

export default component.exports